import Vue from 'vue';
import DialogView from './index.vue';

const Dialog = Vue.extend(DialogView);

export default function dialogPop(message, callback = () => { }, title = null) {
  let instance = new Dialog({});

  instance.message = message;
  instance.title = title;
  instance.callback = callback;

  instance.$mount();
  document.body.appendChild(instance.$el);

  return instance;
}